/** @jsx jsx */

import { jsx, css } from '@emotion/core';
import { truncate } from 'lodash';

import { Grid, Spacer, Text } from '@zapier/design-system';

import Accordion from 'app/common/components/Accordion';
import { convertPlainTextToHtml } from 'app/developer-v3/utils';

import { RequestMethodTypes } from 'app/developer-v3/types/request';

const Styles = {
  contentWrapper: css`
    padding: 10px;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 20px;
    overflow: auto;
  `,
};

type Props = {
  isInitiallyExpanded: boolean;
  date: string;
  requestData: string;
  requestHeaders: string;
  requestMethod: RequestMethodTypes;
  requestUrl: string;
  requestParams?: string;
  responseContent: string;
  responseHeaders: string;
  responseStatusCode: number;
};

const HttpLog = ({
  isInitiallyExpanded,
  date,
  requestData,
  requestHeaders,
  requestMethod,
  requestUrl,
  requestParams,
  responseContent,
  responseHeaders,
  responseStatusCode,
}: Props) => {
  const accordionTitle = (
    <Grid columns="repeat(2, 1fr)" gap={20}>
      <Text fontWeight={600}>
        {requestMethod} {truncate(requestUrl, { length: 35 })}
      </Text>
      <Text textAlign="right">{date}</Text>
    </Grid>
  );

  return (
    <Accordion isInitiallyOpen={isInitiallyExpanded} title={accordionTitle}>
      <Accordion isInitiallyOpen={true} title="Request URL">
        <code css={Styles.contentWrapper}>{requestUrl}</code>
      </Accordion>
      <Spacer height={15} />
      <Accordion isInitiallyOpen={false} title="Request Params">
        <code css={Styles.contentWrapper}>
          {requestParams ? decodeURIComponent(requestParams) : 'N/A'}
        </code>
      </Accordion>
      <Spacer height={15} />
      <Accordion isInitiallyOpen={false} title="Request Headers">
        <code
          css={Styles.contentWrapper}
          dangerouslySetInnerHTML={{
            __html: convertPlainTextToHtml(requestHeaders),
          }}
        />
      </Accordion>
      <Spacer height={15} />
      <Accordion isInitiallyOpen={false} title="Request Data">
        <code
          css={Styles.contentWrapper}
          dangerouslySetInnerHTML={{
            __html: convertPlainTextToHtml(requestData),
          }}
        />
      </Accordion>
      <Spacer height={15} />
      <Accordion isInitiallyOpen={false} title="Response Headers">
        <code
          css={Styles.contentWrapper}
          dangerouslySetInnerHTML={{
            __html: `<strong>Status Code:</strong> ${convertPlainTextToHtml(
              `${responseStatusCode}\n${responseHeaders}`
            )}`,
          }}
        />
      </Accordion>
      <Spacer height={15} />
      <Accordion isInitiallyOpen={false} title="Response Content">
        <code
          css={Styles.contentWrapper}
          dangerouslySetInnerHTML={{
            __html: convertPlainTextToHtml(responseContent),
          }}
        />
      </Accordion>
    </Accordion>
  );
};

export default HttpLog;
